import './Card.less'

import React, { Component } from 'react'
import { translate } from 'react-i18next'
import SchoolIcon from './SchoolIcon'

class Card extends Component {
  render() {
    return (
      <div className={`card-container ${this.props.disabled ? 'disabled-card' : 'card-hover'}`}>
        <h1 className="card-maintenance">{this.props.maintenanceText}</h1>
        <div className="card-body">
          <img src={this.props.img} alt={this.props.title} className="card-img" />
        </div>
        <div className="card-title-container">
          <div className='card-title-inner-container'>
            <SchoolIcon />
            <div className="titles">
              <h2 className="card-title">{this.props.title}</h2>
              {this.props.subTitle && <span className="card-subtitle">{this.props.subTitle}</span>}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default translate('card')(Card)



// WEBPACK FOOTER //
// ./src/components/PlatformSwitch/Card.js